import BlobFile from '@intercom/embercom-composer/lib/blob-file';
import loadImage from 'load-image';
import { bind, scheduleOnce } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create({
  maxWidth: 165,
  maxHeight: 85,
  uploadLogo(file) {
    this.get('uploadManager').incrementProperty('uploadsInProgress');
    this.setEditingState('initial');
    this.set('isResizing', true);
    this.set('logoValueBeforeUpload', this.findOrCreateLogoDatum().get('value'));
    loadImage(file, bind(this, this.gotCanvas), {
      canvas: true,
      orientation: true
    });
  },
  gotCanvas(canvas) {
    this.setScalingFactorAndIsRetina(canvas);
    if (!this.needsResizing(canvas)) {
      this.gotResizedCanvas(canvas);
      return;
    }
    // Show the unprocessed image while we resize
    this.showCanvas(canvas);
    let newDimensions = this.getNewDimensions(canvas);
    this.resizeCanvas(canvas, newDimensions.x, newDimensions.y).then(function () {
      this.showCanvas(canvas);
      this.gotResizedCanvas(canvas);
    }.bind(this));
  },
  needsResizing(canvas) {
    return canvas.width > this.get('maxWidth') || canvas.height > this.get('maxHeight');
  },
  setScalingFactorAndIsRetina(canvas) {
    let scalingFactor = 1;
    let isRetina = false;
    if (canvas.width > this.get('maxWidth') * 2 || canvas.height > this.get('maxHeight') * 2) {
      isRetina = true;
      scalingFactor = 2;
    }
    this.set('scalingFactor', scalingFactor);
    this.set('isRetina', isRetina);
  },
  getNewDimensions(canvas) {
    let newWidth, newHeight;
    let aspectRatio = canvas.width / canvas.height;
    let scalingFactor = this.get('scalingFactor');
    if (canvas.width > canvas.height) {
      newWidth = Math.round(this.get('maxWidth') * scalingFactor);
      newHeight = Math.round(newWidth / aspectRatio);
    } else {
      newHeight = Math.round(this.get('maxHeight') * scalingFactor);
      newWidth = Math.round(newHeight * aspectRatio);
    }
    return {
      x: newWidth,
      y: newHeight
    };
  },
  resizeCanvas(canvas, newWidth, newHeight) {
    return new Em.RSVP.Promise(function (resolve) {
      let oldWidth = canvas.width;
      let oldHeight = canvas.height;
      let worker = new window.Worker('/workers/image-resize.js');
      worker.onmessage = function (event) {
        canvas.getContext('2d').clearRect(0, 0, Math.max(oldWidth, newWidth), Math.max(oldHeight, newHeight));
        canvas.width = newWidth;
        canvas.height = newHeight;
        canvas.getContext('2d').putImageData(event.data.imageData, 0, 0);
        resolve();
      };
      let oldImageData = canvas.getContext('2d').getImageData(0, 0, oldWidth, oldHeight);
      let newImageData = canvas.getContext('2d').getImageData(0, 0, newWidth, newHeight);
      worker.postMessage({
        oldImageData,
        newImageData,
        oldWidth,
        oldHeight,
        newWidth,
        newHeight,
        lobes: 2
      });
    }.bind(this));
  },
  showCanvas(canvas) {
    canvas.toBlob(bind(this, this.showBlob));
  },
  showBlob(blob) {
    let tempUrl = BlobFile.createUrl(blob);
    let logoDatum = this.findOrCreateLogoDatum();
    logoDatum.set('value', {
      url: tempUrl
    });
    this.refreshUI();
  },
  gotResizedCanvas(canvas) {
    this.setProperties({
      uploadWidth: canvas.width,
      uploadHeight: canvas.height,
      isResizing: false
    });
    canvas.toBlob(bind(this, this.gotResizedBlob));
  },
  gotResizedBlob(blob) {
    this.get('uploadManager').decrementProperty('uploadsInProgress');
    this.get('uploadManager').addUpload(blob).then(this.uploadSuccess.bind(this), this.uploadError.bind(this));
  },
  uploadSuccess(policy) {
    let onImageReady = bind(this, function () {
      let logo = this.findOrCreateLogoDatum();
      let value = {
        url: policy.public_url,
        width: this.get('uploadWidth'),
        height: this.get('uploadHeight'),
        isRetina: this.get('isRetina')
      };
      logo.set('value', value);
      this.send('notifyChange', 'logo', value);
      this.refreshUI();
    });
    loadImage(policy.public_url, onImageReady);
  },
  uploadError() {
    this.restoreLogo();
  },
  restoreLogo() {
    this.findOrCreateLogoDatum().set('value', this.get('logoValueBeforeUpload'));
    this.refreshUI();
  },
  findOrCreateLogoDatum() {
    let emailTemplateData = this.get('emailTemplateData');
    let logo = emailTemplateData.findBy('identifier', 'logo');
    if (!logo) {
      logo = Em.Object.create({
        identifier: 'logo'
      });
      emailTemplateData.pushObject(logo);
    }
    return logo;
  },
  sendComposerReadyAction() {
    if (this.isDestroying) {
      return;
    }
    this.onComposerReady?.();
  },
  refreshUI() {
    this.renderWidget();
    scheduleOnce('afterRender', this, this.sendComposerReadyAction);
  }
});